import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ablauf" }
const _hoisted_2 = { class: "features" }
const _hoisted_3 = { class: "feature-wrapper" }
const _hoisted_4 = { class: "feature-grid" }
const _hoisted_5 = { class: "feature-card" }
const _hoisted_6 = { class: "feature-icon" }
const _hoisted_7 = { class: "feature-card" }
const _hoisted_8 = { class: "feature-icon" }
const _hoisted_9 = { class: "feature-card" }
const _hoisted_10 = { class: "feature-icon" }
const _hoisted_11 = { class: "feature-card" }
const _hoisted_12 = { class: "feature-icon" }
const _hoisted_13 = { class: "feature-card" }
const _hoisted_14 = { class: "feature-icon" }

import {CheckCircle, FileText, LayoutTemplate, Mailbox, PhoneCall} from "lucide-vue-next";

import '@/assets/styles/ablauf.css'

export default /*@__PURE__*/_defineComponent({
  __name: 'AblaufView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("h1", null, "So kann Ihr Projekt ablaufen", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Mailbox))
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("h3", null, "1. Anfrage", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, " Sie senden mir eine unverbindliche Anfrage über das Kontaktformular oder direkt über den Projekt-Fragebogen. Für konkrete Projekte empfehle ich den Fragebogen, damit ich Ihr Vorhaben direkt besser einschätzen kann. ", -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(PhoneCall))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("h3", null, "2. Erstgespräch", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", null, " In einem kurzen Gespräch (ca. 10–20 Minuten) klären wir Ihre Ziele, Inhalte und den Umfang der Webseite. Auf Basis Ihrer Angaben erhalten Sie ein individuelles Angebot per E-Mail mit allen Leistungen und Kosten im Überblick. ", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(FileText))
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "3. Angebot & Projektstart", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, " Auf Basis Ihrer Angaben erhalten Sie ein individuelles Angebot per E-Mail. Nach Ihrer Beauftragung starten wir das Projekt und Sie übermitteln mir alle Inhalte über den Projekt-Fragebogen (falls noch nicht ausgefüllt). ", -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(LayoutTemplate))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("h3", null, "4. Design & Anpassungen", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", null, " Auf Basis Ihrer Angaben erstelle ich die Webseite mit bewährter Struktur. Anschließend erhalten Sie eine Vorschau und können Anpassungen mitteilen. ", -1))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(CheckCircle))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("h3", null, "5. Fertigstellung & Veröffentlichung", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, " Nach Ihrer finalen Freigabe wird die Webseite veröffentlicht. Optional übernehme ich auch Hosting und Wartung. ", -1))
          ])
        ]),
        _createVNode(_component_router_link, {
          to: { path: '/kontakt', query: { tab: 'project' } },
          class: "service-btn"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Projekt anfragen ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})